export const SHARING_FB_PID = 'share_al_fb';

export const SHARING_DEFAULT_PID = 'sharing_install';
